import { render, staticRenderFns } from "./TradingViewWidgets.vue?vue&type=template&id=4fe8cddf&scoped=true&"
import script from "./TradingViewWidgets.vue?vue&type=script&lang=js&"
export * from "./TradingViewWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe8cddf",
  null
  
)

export default component.exports